import { render, staticRenderFns } from "./SampleModalConfirmation.vue?vue&type=template&id=79f52fc0"
import script from "./SampleModalConfirmation.vue?vue&type=script&lang=js"
export * from "./SampleModalConfirmation.vue?vue&type=script&lang=js"
import style0 from "./SampleModalConfirmation.vue?vue&type=style&index=0&id=79f52fc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports